export default __webpack_public_path__ + "static/media/architecture-img-21.7db39b81.jpg";